module.exports = __webpack_public_path__ + "static/img_4693-f61e41ea262d9bf5dddf42c725d4e3fa.webp";